// core angular modules
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, inject, Injector, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MsalModule,
  MsalService,
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG
} from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  MsalInstanceFactory,
  MsalInterceptorConfigFactory,
  initializeMsalInstance,
  ConsentScopes
} from '@core/factories/cf2-msal.factory';

// config

// Vendor Modules

// App Modules
import { AppRouterModule } from './app.routes';

// components
import { AppComponent } from './app.component';

import { CoreModule } from '@core/core.module';
import { HomeModule } from '@modules/home/home.module';
import { CommonModule } from '@angular/common';
import { provideNgxMask } from 'ngx-mask';
import { NativeDateModule } from '@angular/material/core';
import { AppInjector } from '@core/services/app-injector.service';
import { NavigationComponent } from '@core/navigation/navigation.component';
import { Cf2MaterialModule } from '@modules/cf2-material/cf2-material.module';
import { HttpClientModule } from '@angular/common/http';
import { TranslocoRootModule } from './transloco/transloco-root.module';
import {RouterModule} from "@angular/router";
import {FormlyModule} from "@ngx-formly/core";

//const ngxMaskOptions: Partial<IConfig> = { validation: false };

// MSAL Guard Configuration
export function MSALGuardConfigFactory() {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ConsentScopes
    },
    loginFailedRoute: '/login-failed'
  };
}

// App initializer function
export function initializeApp(): () => Promise<any> {
  return async (): Promise<any> => {
    try {
      await initializeMsalInstance();
      console.log('MSAL initialized successfully');
      return Promise.resolve();
    } catch (error) {
      console.error('Failed to initialize MSAL:', error);
      // Don't throw the error to prevent app from failing to start
      // MSAL will be initialized on first use instead
      return Promise.resolve();
    }
  };
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    RouterModule,
    NavigationComponent,
    CommonModule,
    CoreModule.forRoot(),
    Cf2MaterialModule,
    BrowserModule,
    MsalModule,
    BrowserAnimationsModule,
    AppRouterModule,
    //NgxMaskModule.forRoot(ngxMaskOptions),
    HomeModule,
    NativeDateModule,
    HttpClientModule,
    TranslocoRootModule
    // FormlyModule.forRoot(),
  ],
  providers: [
    provideNgxMask(),
    {
      provide: MSAL_INSTANCE,
      useFactory: MsalInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MsalInterceptorConfigFactory
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  // providers: [
  //   { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  //   { provide: DateAdapter, useClass: CustomDatePickerAdapter },
  // ],
  exports: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  constructor(injector: Injector) {
    AppInjector.injector = injector;
  }
}
